import { render, staticRenderFns } from "./PaginationSelector.vue?vue&type=template&id=42d3a84d&scoped=true&"
import script from "./PaginationSelector.vue?vue&type=script&lang=ts&"
export * from "./PaginationSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationSelector.vue?vue&type=style&index=0&id=42d3a84d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d3a84d",
  null
  
)

export default component.exports